import { FileInput } from "@mantine/core"
import { FileIcon } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next"
import { MediaApi } from "../../apis"
import { message } from "../../utils/message"

type Props = {
  value: string | null | undefined
  onChange: (url: string) => void
  error?: React.ReactNode
  label: string
  placeholder?: string
  w?: number
}

export function FileField({ value, onChange, error, label, placeholder, w }: Props) {
  const { t } = useTranslation("common")

  async function uploadFile(blob: Blob) {
    try {
      const form = new FormData()
      form.append("file", blob)
      const res = await MediaApi.upload(form)
      if (res?.url) {
        onChange(res.url)
        message.success(t("messages.uploadSuccess"))
      } else {
        throw new Error(t("messages.urlNotFound"))
      }
    } catch (error: any) {
      message.error(error?.message || t("messages.uploadError"))
    }
  }

  const fileName = value ? value.split("/").pop() : ""

  return (
    <FileInput
      value={fileName ? new File([""], fileName, { type: "text/plain" }) : null}
      error={error}
      onChange={(file) => {
        if (file) uploadFile(file)
      }}
      label={label}
      placeholder={placeholder}
      w={w}
      rightSection={<FileIcon />}
    />
  )
}
